import { MAIN_POOL_ID } from '../../../../drift-common/common-ts/lib/constants/misc';
import { useSpotMarkets } from './useSpotMarkets';

export const useIsolatedSpotSymbolToMainSpotSymbolMap = () => {
	const spotMarketConfigs = useSpotMarkets();
	return spotMarketConfigs.reduce((acc, marketConfig) => {
		if (marketConfig.poolId === MAIN_POOL_ID) {
			return acc;
		}

		acc[marketConfig.symbol] = marketConfig.symbol;
		return acc;
	}, {} as Record<string, string>);
};
